import { render, staticRenderFns } from "./DodSettingPreviewPanel.vue?vue&type=template&id=36c1be74&scoped=true&"
import script from "./DodSettingPreviewPanel.vue?vue&type=script&lang=js&"
export * from "./DodSettingPreviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./DodSettingPreviewPanel.vue?vue&type=style&index=0&id=36c1be74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1be74",
  null
  
)

export default component.exports